import { SalesforceField } from 'model/SalesforceField';

export type TemplateComponentType = React.ComponentType<
  Pick<SalesforceField, 'fields' | 'stepName' | 'sectionName' | 'nestedField' | 'onValueSelected'>
>;
